import axios from "axios";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_BASE = "/apiv2";

export const buildApiUrl = (path: string) => {
  return `${API_BASE}${path}`;
};

export const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});
